import { Text, Flex, Box, Heading, Button } from '@chakra-ui/react'
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../../helpers/fontSizesByLang';

function Headquarters() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const fontSizes = fontSizesByLang[i18n.language];

    return (
        <Flex direction="column" w="100%" bg="#1E1D1D">

            <Flex pt={'5%'} justifyContent={'space-around'} pb={'3%'} direction={{ base: 'column', md: 'row' }} mb={{ base: '10%', md: '0%' }}>
                <Flex direction={'column'} pl={{ base: "5%", md: "0%" }}>
                    <Heading fontSize={fontSizes.tittlefont} fontWeight="bold" fontFamily={'Roboto Condensed'} padding={'2%'} pt={'5%'}>
                        <Box
                            as="span"
                            color="white"
                            display={{ base: "block", md: "inline" }}
                        >
                            {t("aboutus-tittle4")}{" "}

                        </Box>
                        <Box as="span" color="#AE8245">
                            {t("aboutus-tittle4.2")}
                        </Box>
                    </Heading>
                    <Text color={"#929292"} fontFamily={'Inter'} p={'1%'} fontSize={fontSizes.textfont}>
                        {t("aboutus-info4")}
                    </Text>
                </Flex>
                <Flex align={'center'} justify={'center'}>
                    <Button
                        onClick={() => navigate("/contact")}
                        width={{ base: '30%', md: '100%', lg: '100%' }}
                        fontSize={{ base: '100%', md: '100%' }}
                        height={{ base: '45px', md: '15%' }}
                        background="#ae8245"
                        color="white"
                        borderRadius="30px"
                        fontFamily="Inter"
                        fontWeight='normal'
                        _hover={{ bg: '#d8973bff' }}
                        padding={5}
                        mt={{ base: 3, md: 0 }}
                    >
                        {t("btnContact")}
                    </Button>
                </Flex>
            </Flex>

        </Flex >



    )
}

export default Headquarters 